import type { Facet, FacetValue } from 'src/components/search/FilterV2/types'
import QuickFilterBrandDecathlonIcon from 'src/components/Icons/QuickFilterBrandDecathlonIcon'
import { useSearch } from '@faststore/sdk'
import PriceTagIcon from 'src/components/Icons/PriceTagIcon'

import QuickFilterButton from './QuickFilterButton'
import { getQuickFiltersFacet } from './QuickFiltersMobile'
import QuickFilterFacetButton from './QuickFIlterFacetButton'

type QuickFiltersMobileProps = {
  facetsv2: Facet[] | undefined
}

const QuickFiltersFacets = ({ facetsv2 }: QuickFiltersMobileProps) => {
  const {
    state: { selectedFacets },
    setFacets,
    setFacet,
  } = useSearch()

  const {
    discountPixFacet,
    discountPixValue,
    facetBrandDecathlon,
    facetBrandDecathlonValue,
  } = getQuickFiltersFacet(facetsv2 ?? [])

  const handleFilterClick = (facetValue: FacetValue) => {
    if (facetValue.selected) {
      const newFacet = selectedFacets.filter(
        (obj) => obj.key !== facetValue.key
      )

      setFacets(newFacet)
    } else {
      setFacet({
        key: facetValue.key,
        value: facetValue.value,
      })
    }
  }

  return (
    <div className="mb-3 mt-2">
      <div className="w-full hidden md:flex items-center justify-center ">
        <div className="flex gap-2 flex-1 flex-wrap">
          <QuickFilterButton
            facetKey={discountPixFacet?.key ?? ''}
            facetValue={discountPixValue}
            onClick={handleFilterClick}
            label="Desconto pix"
            Icon={PriceTagIcon}
          />

          <QuickFilterButton
            facetKey={facetBrandDecathlon?.key ?? ''}
            facetValue={facetBrandDecathlonValue}
            onClick={handleFilterClick}
            label="Marcas Decathlon"
            Icon={QuickFilterBrandDecathlonIcon}
          />
        </div>
      </div>
      <div className="flex gap-2 md:hidden">
        <QuickFilterFacetButton
          facetKey={discountPixFacet?.key ?? ''}
          facetValue={discountPixValue}
          onClick={handleFilterClick}
          label="Promo pix"
          Icon={PriceTagIcon}
        />

        <QuickFilterFacetButton
          facetKey={facetBrandDecathlon?.key ?? ''}
          facetValue={facetBrandDecathlonValue}
          onClick={handleFilterClick}
          label="Marcas Decathlon"
          Icon={QuickFilterBrandDecathlonIcon}
        />
      </div>
    </div>
  )
}

export default QuickFiltersFacets
